<template>
    <v-checkbox
        :model-value="modelValue"
        :disabled="disabled"
        @update:model-value="$emit('update:modelValue', $event)"
        label="Suprafață vizibilă pe ofertă"
        density="compact"
        color="secondary"
        hide-details
    />
</template>

<script>
export default {
    name: "OfferAreaVisibleOnPdfCheckbox",
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["update:modelValue"],
};
</script>
